import { render, staticRenderFns } from "./NameDisplayEditBlock.vue?vue&type=template&id=7f48c1fa&scoped=true&"
import script from "./NameDisplayEditBlock.vue?vue&type=script&lang=js&"
export * from "./NameDisplayEditBlock.vue?vue&type=script&lang=js&"
import style0 from "./NameDisplayEditBlock.vue?vue&type=style&index=0&id=7f48c1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48c1fa",
  null
  
)

export default component.exports